/**
 * V70 엔글 마블 V2 — 게임 방법 모달 (사용자 지시 §11)
 *
 * V2 업데이트 안내 모달은 사용하지 않음.
 * 사용자가 "게임 방법" 버튼을 눌렀을 때 호출되는 상시 안내.
 */
import React from 'react';
import { X, Dices, Flag, Trophy, Shield, Zap } from 'lucide-react';
// V70 2026-10-19 — 서버 전환 안내 분기
import { isPhase3cServerEnabled } from '../shared/phase3cFlag';

export function MarbleHelpModal({ onClose }: { onClose: () => void }) {
  return (
    <div style={backdrop} onClick={onClose}>
      <div style={card} onClick={e => e.stopPropagation()}>
        <div style={titleRow}>
          <h3 style={{ margin: 0, color: '#f1f5f9', fontSize: 20 }}>엔글 마블 게임 방법</h3>
          <button onClick={onClose} style={closeBtn} aria-label="닫기"><X size={18} /></button>
        </div>

        <Section title="🎲 주사위" icon={<Dices size={16} />}>
          <li>24칸 사각 보드를 돌며 플레이합니다.</li>
          <li>주사위를 굴려 나온 눈금 (1~6) 만큼 이동합니다.</li>
          <li>일일 주사위 제한이 있으며, 자정(KST) 에 리셋됩니다.</li>
          <li>관리자가 무제한 모드로 변경하면 횟수 제한 없이 플레이 가능합니다.</li>
        </Section>

        <Section title="🏁 START 완주" icon={<Flag size={16} />}>
          <li>START(1번 칸) 를 통과하거나 정확히 도착하면 <b>+300점</b> 획득.</li>
          <li>가속 아이템으로 통과해도 완주 보상이 지급됩니다.</li>
          <li>워프 이동으로 START 에 도착하는 것은 완주로 인정되지 않습니다.</li>
        </Section>

        <Section title="🏝 무인도 (7번 칸)" icon={null}>
          <li>도착 즉시 무인도에 갇힙니다. 탈출 전까지 이동 불가.</li>
          <li>다음 주사위를 굴려 <b>4·5·6</b> 이 나오면 탈출 성공.</li>
          <li>1·2차 모두 실패 시 <b>3차는 무조건 구조</b> (추가 점수 없음).</li>
          <li>탈출 성공 시 실제 주사위 눈만큼 이동 (가속 적용 불가).</li>
          <li>탈출 실패도 일일 주사위 1회 소모.</li>
        </Section>

        <Section title="💰 보너스 금고 (13번 칸)" icon={null}>
          <li>안전한 금고 (확정 +100점) 또는 행운의 금고 (랜덤 +50~400점) 선택.</li>
          <li>행운의 금고 분포: +400(10%) / +250(20%) / +100(40%) / +50(30%).</li>
        </Section>

        <Section title="🏪 아이템 상점 (19번 칸)" icon={null}>
          <li>🛡 방패 — 150점 (최대 3개 보유)</li>
          <li>🚀 가속 — 100점 (최대 1개 보유)</li>
          <li>점수 부족 또는 최대 보유 상태면 구매 불가.</li>
          <li>"그냥 지나가기" 로 통과 가능.</li>
        </Section>

        <Section title="🛡 방패" icon={<Shield size={16} />}>
          <li>감점 이벤트 발생 시 <b>자동으로 1개 소모</b>하여 손실 완전 방어.</li>
          {/* ISSUE-06: 실제 코드 기반 획득 경로 세 가지 — 가짜 조건 추가 금지 */}
          <li>획득 경로:</li>
          <ul style={{ margin: '2px 0 0', paddingLeft: 20 }}>
            <li>보드의 <b>🛡 방패 획득 이벤트 셀</b> 도착 시 즉시 +1 (해당 셀은 보드마다 2곳 배치).</li>
            <li>아이템 상점 (19번 칸) 에서 <b>150점</b> 으로 구매.</li>
            <li>워프 (10번 이벤트) 로 🛡 방패 획득 셀에 도착 시 즉시 +1.</li>
          </ul>
          <li>최대 3개까지 중첩 보유 가능.</li>
        </Section>

        <Section title="🚀 가속" icon={<Zap size={16} />}>
          <li>다음 주사위 이동 거리 +2 (최대 8칸).</li>
          <li>주사위 굴리기 전 체크박스로 사용 선택.</li>
          <li>무인도 탈출 중에는 사용 불가.</li>
          <li>최대 1개 보유.</li>
        </Section>

        <Section title="🌀 워프" icon={null}>
          {/* ISSUE-04: 워프 셀은 셔플이라 보드 위치가 매 epoch 바뀜 — '11번 칸' 하드코딩 금지.
              고정 칸(START/무인도/금고/상점)과 셔플 셀(E1~E10)의 구분을 명시. */}
          <li>셔플 이벤트 셀 중 하나. <b>보드 위치는 매 시즌(epoch)마다 달라집니다.</b></li>
          <li>현재 위치를 제외한 <b>23칸 중 자유 선택</b>.</li>
          <li>도착 칸의 이벤트가 재발동됩니다.</li>
          <li>워프 이동 자체는 완주 보상이 없습니다.</li>
          <li>워프로 무인도에 도착하면 일반 도착과 동일하게 갇힙니다.</li>
        </Section>

        <Section title="🏆 리더보드" icon={<Trophy size={16} />}>
          <li>누적 점수 TOP 10 노출.</li>
          <li>동점 시 플레이 횟수 적을수록 유리.</li>
          <li>{isPhase3cServerEnabled()
            ? '마블 기록은 서버에 저장되어 전사 공식 리더보드에 반영됩니다.'
            : '마블은 이 브라우저에서 플레이한 기록으로 집계됩니다.'}</li>
        </Section>

        <div style={{ textAlign: 'right', marginTop: 20 }}>
          <button onClick={onClose} style={doneBtn}>확인</button>
        </div>
      </div>
    </div>
  );
}

function Section({ title, icon, children }: { title: string; icon: React.ReactNode; children: React.ReactNode }) {
  return (
    <div style={{ marginBottom: 16 }}>
      <h4 style={{ color: '#22d3ee', fontSize: 14, margin: '0 0 6px', display: 'flex', alignItems: 'center', gap: 6 }}>
        {icon} {title}
      </h4>
      <ul style={{ margin: 0, paddingLeft: 20, color: '#cbd5e1', fontSize: 13, lineHeight: 1.7 }}>
        {children}
      </ul>
    </div>
  );
}

const backdrop: React.CSSProperties = {
  position: 'fixed', inset: 0, background: 'rgba(2,6,23,0.75)', zIndex: 1000,
  display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20,
  overflowY: 'auto',
};
const card: React.CSSProperties = {
  background: '#0b1220', border: '1px solid #334155', borderRadius: 12,
  padding: 24, maxWidth: 640, width: '100%', color: '#e2e8f0',
  maxHeight: '90vh', overflowY: 'auto',
};
const titleRow: React.CSSProperties = {
  display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 20,
};
const closeBtn: React.CSSProperties = {
  background: 'transparent', border: 0, color: '#94a3b8', cursor: 'pointer', padding: 4,
};
const doneBtn: React.CSSProperties = {
  padding: '10px 24px',
  background: 'linear-gradient(135deg, #06b6d4, #22d3ee)', color: '#042f3b',
  fontWeight: 700, border: 0, borderRadius: 8, cursor: 'pointer',
};

export default MarbleHelpModal;
